import { Button, Card } from '@/components/ui';
import type { EntertainmentTransaction } from '@/lib/entertainment/ledger-types';
import { formatCurrency } from '@/lib/utils';

type Props = {
  transactions: EntertainmentTransaction[];
  onApprove: (transactionId: string) => void;
  onReject: (transactionId: string) => void;
};

export function ApprovalQueue({ transactions, onApprove, onReject }: Props) {
  const pending = transactions.filter((transaction) =>
    transaction.kind === 'shared_cost' && transaction.status === 'pending'
  );

  return (
    <Card>
      <div className="flex flex-col gap-3">
        <h2 className="text-sm font-bold text-aura-primary mb-3 uppercase tracking-widest">
          Pending Approvals ({pending.length})
        </h2>
        {pending.length === 0 ? (
          <div className="py-8 text-center text-sm font-semibold text-aura-primary/40">No pending shared costs.</div>
        ) : (
          pending.map((transaction) => (
            <div key={transaction.id} className="flex items-center justify-between gap-3 border-t border-border-subtle py-3 first:border-t-0">
              <div className="min-w-0">
                <div className="truncate text-sm font-medium text-text-main">{transaction.description}</div>
                <div className="text-xs text-text-muted">
                  {formatCurrency(transaction.amount_cents / 100)}
                </div>
              </div>
              <div className="flex shrink-0 gap-2">
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="text-status-error hover:text-red-700"
                  aria-label={`Reject ${transaction.description}`}
                  onClick={() => onReject(transaction.id)}
                >
                  Reject
                </Button>
                <Button
                  type="button"
                  size="sm"
                  className="text-white"
                  aria-label={`Approve ${transaction.description}`}
                  onClick={() => onApprove(transaction.id)}
                >
                  Approve
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </Card>
  );
}
